module.exports = __webpack_public_path__ + "img/maskinpark.8cc9e904.jpg";